export const FORMS_LOAD_ERROR = 'Could not load forms.';

export const FORMS_UPDATE_ERROR = 'Could not update form.';

export const FORMS_DUPLICATE_ERROR = 'Could not duplicate form.';

export const FORMS_DUPLICATE_SUCCESS = 'Form duplicated successfully.';

export const FORMS_ROUTE = '/forms';

export const formEditRoute = (formId) => `${FORMS_ROUTE}/${encodeURIComponent(formId)}`;

export const formSubmissionsRoute = (formId) =>
  `${FORMS_ROUTE}/${encodeURIComponent(formId)}/submissions`;
